import React from 'react';
import styles from '../Home.module.css';

const Experience = (props) => {
  const { title } = props;

  return (
    <div className={styles.contentContainer}>
      <div className={styles.about}>
        <h2 className={styles.title}>{title}</h2>

        <div>
          <ul className={`${styles.list} ${styles.text}`}>
            <li>
              <p>Agentic Study Assistant – Retrieval-Augmented AI System</p>
              <span>December 2025 - Present</span>
              <ul>
                <li>
                  Architected end-to-end RAG system using hybrid retrieval
                  (pgvector + keyword search) with dynamic gating to control
                  context injection.
                </li>
                <li>
                  Engineered multi-stage ranking pipeline over top-K similarity
                  results incorporating confidence thresholds, deduplication,
                  reranking, and token-budget enforcement prior to context
                  assembly.
                </li>
                <li>
                  Implemented hierarchical summarization and intelligent pruning
                  to manage long-running sessions within strict LLM context
                  limits.
                </li>
                <li>
                  Built Redis-backed short-term session state and
                  PostgreSQL-based long-term memory with embedding similarity
                  matching and async knowledge extraction.
                </li>
                <li>
                  Designed and implemented scenario-based evaluation framework
                  with custom scoring evaluators (Recall@K, MRR) to measure
                  retrieval ranking, filtering accuracy, and downstream agent
                  behavior across curated datasets.
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div>
          <div className={styles.jobTitle}>
            <span className={styles.text}>
              Software Engineer III @ Axiom
            </span>
            <span className={styles.text}>June 2022 – February 2026</span>
          </div>
          <ul className={`${styles.list} ${styles.text}`}>
            <li>
              Built and shipped an automated interview scheduling system
              orchestrating availability resolution, calendar coordination, and
              constraint handling through a controlled LLM + tool execution
              workflow, reducing manual scheduling effort by ~40% and improving
              turnaround time
            </li>
            <li>
              Architected a LangGraph-based agent system integrating hybrid
              retrieval (pgvector + keyword), tool execution, and memory, with
              explicit routing and context control to support multi-step
              workflows
            </li>
            <li>
              Engineered a tool execution framework constraining LLM-selected
              actions through schema validation, input checks, and guarded
              fallbacks, preventing invalid tool execution and ensuring reliable
              interaction with calendar APIs and internal systems
            </li>
            <li>
              Designed an append-only execution trace system to enable
              reproducibility, debugging, and offline evaluation of multi-step
              agent workflows
            </li>
            <li>
              Built asynchronous worker queue pipelines to process AI workloads
              (ingestion, summarization, extraction), decoupling LLM reasoning
              from side-effect execution to improve throughput, reduce latency,
              and enable reliable concurrent processing
            </li>
          </ul>
        </div>

        <div>
          <div className={styles.jobTitle}>
            <span className={styles.text}>
              Software Engineer @ Fresh Consulting
            </span>
            <span className={styles.text}>May 2021 – May 2022</span>
          </div>
          <ul className={`${styles.list} ${styles.text}`}>
            <li>
              Led frontend architecture for a cross-platform web and mobile
              application serving thousands of daily users, focusing on
              scalability, performance, and maintainability.
            </li>
            <li>
              Implemented backend APIs and database migrations supporting
              evolving production data models and internal platform services.
            </li>
            <li>
              Collaborated with product on API design and data modeling to
              support complex, data-driven workflows.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Experience;
